/* Full-screen personalisation configurator (snippets/runit-personalise.liquid, .rl-pz--pzc).
   assets/runit-personalise.js still owns the state, drawing, prices and cart properties; this file only
   opens and closes the <dialog>, steps through its panels and writes the closed-state chip. It reads the
   personaliser's own inputs and data-pz-price, and redraws on its runit:pz-change event. */
(function () {
  function money(p) { return '£' + (p / 100).toFixed(p % 100 ? 2 : 0); }

  function init(root) {
    root.setAttribute('data-pzc-ready', '');
    var dlg = root.querySelector('[data-pzc]');
    if (!dlg) return;
    var $ = function (s) { return root.querySelector(s); };
    var form = document.getElementById(root.dataset.form);
    var steps = Array.prototype.slice.call(dlg.querySelectorAll('[data-pzc-step]'));
    var tabs = Array.prototype.slice.call(dlg.querySelectorAll('[data-pzc-tab]'));
    var next = $('[data-pzc-next]'), back = $('[data-pzc-back]'), totalEl = $('[data-pzc-total]');
    var lines = $('[data-pzc-lines]'), countEl = $('[data-pzc-count]'), agree = $('[data-pz-agree]');
    var chip = $('[data-pzc-chip]'), chipText = $('[data-pzc-chip-text]'), openBtn = $('.rl-pzc-open');
    var view = $('[data-pz-view]'), front = $('[data-pzc-front]');
    var product = ($('[data-pzc-product]') || { dataset: {} }).dataset.pzcProduct || '';
    // Personalisation variants 'title=id=price' (snippet data-variants), for each review row's own price.
    var V = {};
    (root.dataset.variants || '').split('|').forEach(function (row) { var p = row.split('='); if (p.length === 3) V[p[0]] = +p[2]; });
    var cur = null;
    steps.forEach(function (s) { s.tabIndex = -1; });

    // Garment price per variant id, from the personaliser's own id=price=url map.
    var PRICES = {};
    (root.dataset.variantMedia || '').split('|').forEach(function (row) { var p = row.split('='); PRICES[p[0]] = +p[1] || 0; });
    function garment() { return PRICES[((form && form.querySelector('[name="id"]')) || {}).value] || 0; }

    function picked(name) { var r = root.querySelector('input[name="' + name + '"]:checked'); return r ? r.value : ''; }
    function kind() { return picked('rl-pz-kind'); }
    function stars() { return picked('rl-pz-stars'); }
    function textInput() { var k = kind(); return k ? $({ instagram: '[data-pz-input-ig]', text: '[data-pz-input-text]', plate: '[data-pz-input-plate]' }[k]) : null; }
    function text() { var i = textInput(); return i ? i.value.trim().split('\n').map(function (l) { return l.trim(); }).filter(Boolean).join(' / ') : ''; } // a two-line plate reads 'MY / 636'
    function on() { return !!(kind() || stars()); }
    function refl() { var r = $('[data-pz-refl]'); return !!(r && r.checked && kind() && kind() !== 'plate'); }
    function starCol() { var r = $('[data-pz-star-col]:checked'); return r && r.value === 'white' ? 'White' : 'Yellow'; }
    function ready() { return !on() || (agree.checked && (!kind() || !!text())); }
    // One row per add-on: [label, price in pence]. The last row takes any gap to the combined variant's price.
    function rows(total) {
      var k = kind(), t = text(), out = [], base = { instagram: 'Instagram', text: 'Custom Text', plate: 'Plate' }[k];
      // One plain line per add-on, saying what it is and what they typed (owner, 4 Nov):
      // 'Reflective Instagram handle: @MYBROTHER  +£10', 'Plate: TY07 / DOD  +£5'.
      var shown = { instagram: t && '@' + t, text: t && '“' + t + '”', plate: t }[k];
      var name = refl() ? { instagram: 'Reflective Instagram handle', text: 'Reflective custom text' }[k]
        : { instagram: 'Instagram handle', text: 'Custom text', plate: 'Plate' }[k];
      if (k) out.push([name + (shown ? ': ' + shown : ''), V[refl() ? 'Reflective ' + base : base] || 0]);
      if (stars()) out.push([stars() + ' wanted stars on the sleeves, ' + (starCol() === 'White' ? 'reflective white' : 'yellow'), V[stars() + ' Stars'] || 0]);
      var sum = out.reduce(function (a, r) { return a + r[1]; }, 0);
      if (out.length) out[out.length - 1][1] += total - sum;
      return out;
    }
    // The closed chip, short and one add-on per line: 'Reflective @MYBROTHER' / '5 reflective white stars'.
    function parts() {
      var k = kind(), t = text(), out = [], r = refl() ? 'Reflective ' : '';
      if (k === 'instagram') out.push(r + (t ? '@' + t : 'Instagram handle'));
      if (k === 'text') out.push(r + (t ? '“' + t + '”' : 'custom text'));
      if (k === 'plate') out.push(t ? 'Plate ' + t : 'Plate');
      if (stars()) out.push(stars() + (starCol() === 'White' ? ' reflective white' : ' yellow') + ' stars');
      return out;
    }
    // The steps in play: blank backs and tees render fewer tabs. The text box opens under Add itself.
    function avail() { return tabs.map(function (b) { return b.dataset.pzcTab; }); }
    function line(label, value, cls) {
      var li = document.createElement('li'); if (cls) li.className = cls;
      var a = document.createElement('span'); a.textContent = label; li.appendChild(a);
      if (value) { var b = document.createElement('span'); b.textContent = value; li.appendChild(b); }
      lines.appendChild(li);
    }

    function update() {
      var list = avail(), extra = on() ? +root.dataset.pzPrice || 0 : 0;
      if (list.indexOf(cur) < 0) cur = list[0];
      dlg.dataset.pzcAt = cur; // the CSS keeps Add from scrolling
      steps.forEach(function (s) { s.hidden = s.dataset.pzcStep !== cur; });
      tabs.forEach(function (b) {
        var n = b.dataset.pzcTab; b.parentNode.hidden = list.indexOf(n) < 0;
        if (n === cur) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      });
      var input = textInput();
      if (countEl) countEl.textContent = input ? input.value.replace(/\n/g, '').length + ' / ' + (+input.dataset.pzMax || input.maxLength) + ' characters' : '';
      lines.textContent = '';
      line(product, money(garment()));
      if (on()) rows(extra).forEach(function (r) { line(r[0], '+' + money(r[1])); });
      else line('No personalisation', '');
      if (kind() && !text()) line({ instagram: 'Add your Instagram handle under Add.', text: 'Add your text under Add.', plate: 'Type your plate letters and numbers under Add.' }[kind()], '', 'rl-pzc__need');
      totalEl.textContent = money(garment() + extra);
      var last = cur === list[list.length - 1];
      next.textContent = last ? 'Done' : 'Next';
      back.hidden = list.indexOf(cur) <= 0;
      chip.hidden = !on(); openBtn.hidden = on();
      chipText.textContent = '';
      if (on()) {
        var head = document.createElement('span'); head.className = 'rl-pzc-chip__head'; head.textContent = 'Personalised +' + money(extra);
        var sub = document.createElement('span'); sub.className = 'rl-pzc-chip__sub'; sub.textContent = parts().join('\n');
        chipText.append(head, sub);
      }
    }

    // Once chosen, the personalised back replaces that shot in the product gallery; removed, the photo comes back.
    // ponytail: a gallery re-rendered by a variant change shows the plain photo until the next change here.
    var shown = null, shotUrl = '';
    function file(u) { return (u || '').split('?')[0].split('/').pop().replace(/_\d*x\d*(?=\.)/, ''); }
    function gallery() {
      if (shown && !on()) {
        shown.src = shown.dataset.pzSrc; if (shown.dataset.pzSrcset) shown.srcset = shown.dataset.pzSrcset;
        shown = null;
      }
      if (!on() || dlg.open || !root.rlPzSnapshot) return;
      var base = $('[data-pz-base]'), scope = root.closest('.shopify-section') || document;
      var imgs = Array.prototype.slice.call(scope.querySelectorAll('media-gallery .product__media img'));
      var img = imgs.filter(function (i) { return base && file(i.currentSrc || i.src) === file(base.currentSrc || base.src); })[0] || imgs[0];
      if (!img) return;
      root.rlPzSnapshot().then(function (blob) {
        if (!blob || !on()) return;
        if (!img.dataset.pzSrc) { img.dataset.pzSrc = img.src; img.dataset.pzSrcset = img.getAttribute('srcset') || ''; }
        if (shotUrl) URL.revokeObjectURL(shotUrl);
        shotUrl = URL.createObjectURL(blob);
        img.removeAttribute('srcset'); img.src = shotUrl; shown = img;
      });
    }

    function go(name) {
      cur = name; update();
      var s = steps.filter(function (x) { return x.dataset.pzcStep === cur; })[0];
      if (s) { s.parentNode.scrollTop = 0; ((cur === 'add' && kind() && !text() && textInput()) || s).focus({ preventScroll: true }); }
    }
    function showView(which) {
      if (!front) return;
      front.hidden = which !== 'front'; view.hidden = which === 'front';
      dlg.querySelectorAll('[data-pzc-view]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.pzcView === which)); });
    }
    var returnTo = null, lockY = 0;
    // iOS Safari ignores overflow:hidden on <html>, so pin the body instead and restore the scroll.
    function lock() { lockY = window.scrollY; document.documentElement.classList.add('rl-pzc-lock'); document.body.style.top = -lockY + 'px'; }
    function unlock() { document.documentElement.classList.remove('rl-pzc-lock'); document.body.style.top = ''; window.scrollTo(0, lockY); }
    // Older browsers (iOS < 15.4) have no showModal/close: fall back to the open attribute.
    function shut() { if (typeof dlg.close === 'function') dlg.close(); else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); } }
    function open(step) {
      if (dlg.open) { if (step) go(step); return; }
      returnTo = document.activeElement;
      var base = $('[data-pz-base]'); if (base) base.fetchPriority = 'high';
      if (front) front.loading = 'eager';
      showView('back');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); lock();
      go(step || avail()[0]);
    }
    dlg.addEventListener('close', function () {
      unlock();
      gallery();
      var back = on() ? chip.querySelector('[data-pzc-open]') : openBtn;
      (returnTo && returnTo.isConnected && returnTo.offsetParent ? returnTo : back).focus();
    });

    root.querySelectorAll('[data-pzc-open]').forEach(function (b) { b.addEventListener('click', function () { open(); }); });
    $('[data-pzc-close]').addEventListener('click', function () { shut(); });
    tabs.forEach(function (b) { b.addEventListener('click', function () { go(b.dataset.pzcTab); }); });
    back.addEventListener('click', function () { var l = avail(); go(l[Math.max(0, l.indexOf(cur) - 1)]); });
    next.addEventListener('click', function () {
      var l = avail(), i = l.indexOf(cur);
      if (i < l.length - 1) go(l[i + 1]);
      else if (ready()) shut();
      else if (kind() && !text()) go('add');
      else if (root.rlPzRequireAgree) root.rlPzRequireAgree(); // red box round the agreement; stays open
    });
    dlg.querySelectorAll('[data-pzc-view]').forEach(function (b) { b.addEventListener('click', function () { showView(b.dataset.pzcView); }); });

    // Remove: back to no personalisation, through the personaliser's own change handler.
    $('[data-pzc-remove]').addEventListener('click', function () {
      ['rl-pz-kind', 'rl-pz-stars'].forEach(function (n) {
        var none = root.querySelector('input[name="' + n + '"][value=""]');
        if (none && !none.checked) { none.checked = true; none.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      [$('[data-pz-refl]'), agree].forEach(function (c) { if (c && c.checked) { c.checked = false; c.dispatchEvent(new Event('change', { bubbles: true })); } });
      openBtn.focus();
    });

    root.addEventListener('runit:pz-change', function () { showView('back'); update(); if (!dlg.open) gallery(); });
    // Add to Bag stopped by the personaliser's checks (missing text, no tick): show it on Review.
    root.addEventListener('runit:pz-fail', function () { if (!root.hasAttribute('data-pz-piece')) open('review'); });
    update();
  }

  function initAll() { document.querySelectorAll('.rl-pz--pzc[data-runit-personalise]:not([data-pzc-ready])').forEach(init); }
  initAll();
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
